









import Vue from 'vue';
import Component from 'vue-class-component';
import DMenu from '../../index';

Vue.use(DMenu);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  // TODO
}
